import { render, staticRenderFns } from "./ptspprovinsi.vue?vue&type=template&id=45f1a6d6"
import script from "./ptspprovinsi.vue?vue&type=script&lang=js"
export * from "./ptspprovinsi.vue?vue&type=script&lang=js"
import style0 from "./ptspprovinsi.vue?vue&type=style&index=0&id=45f1a6d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports